export enum RequestPurposeTypeEnum{
  Research= 'Research',
  Commercial= 'Commercial'
}
